import type React from 'react';
import type { ReactNode } from 'react';

import type { Outcome } from '../../schema/coupon/entry.js';
import type { EventNumber } from '../../schema/sport/entry.js';
import CouponOutcomePrediction, { type CouponOutcomePredictionBaseProps } from './Coupon.OutcomePrediction.js';

type CouponOutcomeWrapperProps = CouponOutcomePredictionBaseProps & {
  eventNumber: EventNumber;
  correctOutcome?: Outcome;
  isMasked?: boolean;
  outcomeStatus?: React.ComponentProps<typeof CouponOutcomePrediction>['status'];
};

/**
 * Coupon event outcome component.
 * Could later be styled with best bet row indicator etc.
 *
 * @param root0 props for CouponOutcomeWrapper
 * @param root0.eventNumber event number for the coupon event
 * @param root0.correctOutcome correct outcome for the event
 * @param root0.isMasked whether the event is masked
 * @param root0.outcomeStatus optional outcome status to be set from parent component
 * @returns Coupon event outcome component
 */
export default function CouponOutcomeWrapper({
  eventNumber,
  correctOutcome,
  isMasked,
  outcomeStatus,
  ...props
}: CouponOutcomeWrapperProps): ReactNode {
  const isCurrentResult = props.index === correctOutcome;
  const isCorrectOutcome = props.isSelected && isCurrentResult;
  const status = isCorrectOutcome ? 'correct' : 'incorrect';
  const componentStatus = isCurrentResult ? (outcomeStatus ?? status) : 'default';
  return (
    <CouponOutcomePrediction {...props} eventNumber={eventNumber} status={isMasked ? 'default' : componentStatus} />
  );
}
